var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFFAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAE5",
    d: "M8.32 8.32h15.36v15.36H8.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.36 12.8h1.28v1.28h-1.28V12.8zm0 2.56h1.28v3.84h-1.28v-3.84zM16 9.6A6.402 6.402 0 009.6 16c0 3.533 2.868 6.4 6.4 6.4 3.533 0 6.4-2.867 6.4-6.4 0-3.532-2.867-6.4-6.4-6.4zm0 11.52A5.127 5.127 0 0110.88 16 5.127 5.127 0 0116 10.88 5.127 5.127 0 0121.12 16 5.127 5.127 0 0116 21.12z",
    fill: "#9D7B00"
  })));
}
export default SvgInfoWarning;